/* istanbul ignore file */
import { Option } from './dropdownHelper';
import SelectInput, { SelectInputProps } from './SelectInput';
import { getTimezonesOptions } from 'framework/utils';

const MOST_USABLE_TIMESONES = ['Eastern', 'Central', 'Mountain', 'Pacific'];

const TimezoneDropdown = (props: SelectInputProps) => {
  const timezonesOptions = getTimezonesOptions();

  const popularTimezones = timezonesOptions.filter(({ label }: Option) =>
    MOST_USABLE_TIMESONES.find((timezone: string) => (label as string).endsWith(timezone)),
  );

  const groupedOptions = [
    {
      label: 'Populars',
      options: popularTimezones,
    },
    {
      label: 'All',
      options: timezonesOptions.map((option: Option) => ({ ...option, isSearchable: true })),
    },
  ];

  return (
    <SelectInput
      {...props}
      options={groupedOptions}
      filterOption={(option: { data: Option }, rawInput: string): boolean =>
        ((option.data.label as string).toLowerCase().includes(rawInput.toLowerCase()) && option.data.isSearchable) ||
        !rawInput
      }
      noOptionsMessage={() => 'Time zone not found'}
    />
  );
};

export default TimezoneDropdown;
